<template>
  <PopupBase
    @close-pop-up="closePopUp"
    class="accumulator-selector-disclaimer"
    v-bind="$attrs"
  >
    <div class="accumulator-selector-disclaimer__content">
      <h3
        v-tv:hydraulicSelector="'disclaimerHeadline'"
      />
      <Markdown
        :text="$tv('disclaimerText', 'accumulatorSelector')"
      />
      <div class="accumulator-selector-disclaimer__actions">
        <Checkbox
          :label="$tv('disclaimerCheckboxLabel', 'accumulatorSelector')"
          @change="acceptedDisclaimer = !acceptedDisclaimer"
          :disabled="!checkboxReady"
        />
        <ReactiveButton
          :button-text="$tv('accept', 'hydraulicSelector')"
          :disabled="disableButton"
          @click="closePopUp"
        />
      </div>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">
import PopupBase from './PopupBase.vue'
import Checkbox from '~/components/input-components/Checkbox'
import ReactiveButton from '~/components/ReactiveButton'
import {useConfigurationDataStore} from '@/store/configuration-data'

const acceptedDisclaimer = ref(false)
const checkboxReady = ref(false)
const disableButton = computed(() => {
  return !acceptedDisclaimer.value
})

const closePopUp = () => {
  useConfigurationDataStore().acceptedAccumulatorSelectorDisclaimer = acceptedDisclaimer.value
}

onMounted(() => {
  checkboxReady.value = true
})

</script>

<style lang="scss">
.accumulator-selector-disclaimer {
  &__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: left;

    h3 {
      margin: 0;
    }
  }

  &__actions {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .popup > .popup__wrapper > .popup__content > .close {
    display: none;
  }
}

body:has(.accumulator-selector-disclaimer.popup--visible) {
  overflow: hidden;
}
</style>
